import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "types" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { id: "chart-config" }, "ChartConfig", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-0" }, " Chart config object is used to set size, margin, direction and axis. ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" See: ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("AxisConfig")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Margin")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Size")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", {
  id: "axis",
  class: "mt-6"
}, "AxisConfig", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mt-0" }, "Config the chart axis.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", {
  id: "size",
  class: "mt-6"
}, "Size", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mt-0" }, "Chart size.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", {
  id: "margin",
  class: "mt-6"
}, "Margin", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mt-0" }, "Chart margins.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CodeBlock = _resolveComponent("CodeBlock")!
  const _component_PrismEditor = _resolveComponent("PrismEditor")!
  const _component_TabBlock = _resolveComponent("TabBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, [
      _hoisted_4,
      _createVNode(_component_router_link, { to: "#axis" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6,
      _createVNode(_component_router_link, { to: "#margin" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _hoisted_8,
      _createVNode(_component_router_link, { to: "#size" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_CodeBlock, {
      code: _ctx.code.chartConfig,
      class: "mt-4"
    }, null, 8, ["code"]),
    _hoisted_10,
    _hoisted_11,
    _createVNode(_component_TabBlock, { tabs: [
        { label: 'Type', icon: 'text_fields' },
        { label: 'Default Value', icon: 'receipt_long' }
      ] }, {
      default: _withCtx(({ selected }) => [
        (selected === 0)
          ? (_openBlock(), _createBlock(_component_PrismEditor, {
              key: 0,
              code: _ctx.code.axis,
              readonly: true
            }, null, 8, ["code"]))
          : _createCommentVNode("", true),
        (selected === 1)
          ? (_openBlock(), _createBlock(_component_PrismEditor, {
              key: 1,
              code: _ctx.code.axisDefault,
              readonly: true
            }, null, 8, ["code"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_12,
    _hoisted_13,
    _createVNode(_component_CodeBlock, {
      code: _ctx.code.size,
      class: "mt-4"
    }, null, 8, ["code"]),
    _hoisted_14,
    _hoisted_15,
    _createVNode(_component_CodeBlock, {
      code: _ctx.code.margin,
      class: "mt-4"
    }, null, 8, ["code"])
  ]))
}